import { Component, Input, Output, EventEmitter, ViewEncapsulation, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormArray } from '@angular/forms';
import { Misc } from '../util/misc';
import { ToastrComponent } from '../util/toastr/toastr.component';
import { Erf } from 'src/app/models/erf.model';
import { PlanejamentoService } from 'src/app/services/planejamento.service';
import { GestaoService } from 'src/app/services/gestao.service';
import { PriceParamProjetoService } from 'src/app/services/price-param-projeto.service';
import { PriceParamService } from 'src/app/services/price-param.service';
import { FaturamentoService } from 'src/app/services/faturamento.service';
import { ValidacaoService } from 'src/app/services/validacao.service';
import { UtilService } from 'src/app/services/util.service';
import { CalculoService } from 'src/app/services/calculo.service';
import { EstimativaService } from 'src/app/services/estimativa.service';
import * as constants from 'src/app/models/constants/constants';
import { MatDialog } from '@angular/material/dialog';
import {
  StaffPlanPrazoDialogComponent,
  PrazoAction,
} from './../../shared/components/staff-plan-prazo-dialog/staff-plan-prazo-dialog.component';
import { StaffPlanBridgeService } from 'src/app/services/staff-plan-bridge.service';

@Component({
  selector: 'app-planejamento-form',
  templateUrl: './planejamento-form.component.html',
  styleUrls: ['./planejamento-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PlanejamentoFormComponent implements OnInit {
  @Input() estimativaId: number;
  @Input() somenteLeitura: boolean;
  @Input() hiddenResume: boolean;
  @Output() comissaoAlterada = new EventEmitter();
  @Output() prazoAcao = new EventEmitter<{ action: PrazoAction; novoPrazo: number; delta: number }>();

  loading: boolean;

  formAux = null;
  basicFormPlaneja: UntypedFormGroup;
  estimativaTipo: number;
  tipoDelivery: boolean;

  dtPrevInicio: string = '';

  prazoAnterior: number | null = null;

  private prazoWasEmptyOnFocus = false;

  private pendingPrazoEmit: { action: PrazoAction; novoPrazo: number; delta: number } | null = null;

  constructor(
    private fb: UntypedFormBuilder,
    private planejamentoService: PlanejamentoService,
    private gestaoService: GestaoService,
    private priceParamProjetoService: PriceParamProjetoService,
    private estimativaService: EstimativaService,
    private priceParamService: PriceParamService,
    private faturamentoService: FaturamentoService,
    private validacaoService: ValidacaoService,
    public utilService: UtilService,
    private calculoService: CalculoService,
    public misc: Misc,
    private toastr: ToastrComponent,
    private dialog: MatDialog,
    private staffPlanBridge: StaffPlanBridgeService,
  ) {
    this.createForm();
  }

  createForm() {
    this.basicFormPlaneja = this.fb.group({
      id: [0],
      estimativaId: [null],
      planejamento: this.fb.group({
        id: [0],
        estimativaId: [null],
        inicioPlanejaInput: [null, [Validators.required]],
        inicioPlanejaHoraInput: [null],
        especFuncInput: [null, [Validators.required]],
        especFuncHoraInput: [null],
        especTecnicaInput: [null, [Validators.required]],
        especTecnicaHoraInput: [null],
        aceiteInternoInput: [null],
        construTeste: [0],
        testeIntegraInput: [null, [Validators.required]],
        testeIntegraHoraInput: [null],
        homologaCertiInput: [null, [Validators.required]],
        homologaCertiHoraInput: [null],
        implantaInput: [null, [Validators.required]],
        implantaHoraInput: [null],
        posImplanta: [null, [Validators.required]],
        docCmmi: [0],
        planejacol: [null],
        risco: [0],
        prazoProjetoInput: [0],
        dtPrevInicio: [null],
      }),
      dtInclusao: [null],
      estimativa: [null],
      gestao: this.fb.group({
        id: [0],
        estimativaId: [null],
        gestaoInformaInput: [null, [Validators.required]],
        gestaoInformaHoraInput: [null],
        riscoTecnicoInput: [null, [Validators.required]],
        riscoTecnicoHoraInput: [null],
        totalProjeto: [null],
        totalProjetoGestao: [null],
        mediaEquipe: [null],
        custoHora: [null],
        totalHoras: [null],
      }),
      param_administrativo: [null],
      param_comissao: this.fb.group({
        id: [null],
        estimativaId: [null],
        priceParamId: [null],
        nome: [null],
        ativo: [null],
        editavel: [null],
        valor: [null],
      }),
      param_imposto: [null],
      param_investimento: [null],
    });
  }

  ngOnInit() {
    this.estimativaService.getEstimativaTipo(this.estimativaId).subscribe((result: any) => {
      this.estimativaTipo = result.estimativaTipoId;

      if (this.estimativaTipo === 3) {
        this.somenteLeitura = false;
        this.tipoDelivery = true;
      }

      this.estimativaService.getById(this.estimativaId).subscribe((estimativa: any) => {
        if (estimativa.statusId === constants.EstimativaStatusConstants.ID_ESTIMATIVA_APROVADA) {
          this.somenteLeitura = true;
        }

        if (this.somenteLeitura || !this.hiddenResume) {
          this.disableAllControls(this.basicFormPlaneja);
        }

        this.basicFormPlaneja.patchValue({
          estimativaId: this.estimativaId,
          planejamento: { estimativaId: this.estimativaId },
          gestao: { estimativaId: this.estimativaId },
          param_comissao: { estimativaId: this.estimativaId },
        });

        this.carregarParametros().then(() => {
          this.carregar().then(() => {
            this.calcular(false);
          });
        });
      });
    });
  }

  habilitarAba() {
    return this.validacaoService.validarParametros(this.estimativaId).subscribe((res) => {
      let enabled = res;
      this.utilService.setBoolParams(enabled);
      this.utilService.currentBoolParams.subscribe((b) => (enabled = b));
    });
  }

  calcular(save?: boolean) {
    if (save === true && !this.validaControles()) return;

    let dataFormatada = null;

    if (this.dtPrevInicio && typeof this.dtPrevInicio === 'string') {
      const partes = this.dtPrevInicio.split('/');
      if (partes.length === 3) {
        const [dia, mes, ano] = partes;
        if (dia && mes && ano) dataFormatada = `${ano}-${mes}-${dia}`;
      }
    }

    const erf = {
      planeja: {
        ...this.basicFormPlaneja.getRawValue().planejamento,
        dtPrevInicio: dataFormatada,
      },
      gestao: this.basicFormPlaneja.getRawValue().gestao,
    } as Erf;

    this.calculoService.calcularErf(erf).subscribe((result) => {
      if (!result) return;

      this.loading = true;
      setTimeout(() => {
        this.basicFormPlaneja.patchValue({
          planejamento: {
            inicioPlanejaHoraInput: result.planeja.inicioPlaneja.toFixed(2),
            especFuncHoraInput: result.planeja.especFunc.toFixed(2),
            especTecnicaHoraInput: result.planeja.especTecnica.toFixed(2),
            testeIntegraHoraInput: result.planeja.testeIntegra.toFixed(2),
            homologaCertiHoraInput: result.planeja.homologaCerti.toFixed(2),
            implantaHoraInput: result.planeja.implanta.toFixed(2),
            planejacol: result.planeja.planejacol.toFixed(2),
            prazoProjetoInput: result.planeja.prazoProjetoInput,
            dtPrevInicio: result.planeja.dtPrevInicio,
          },
        });

        this.basicFormPlaneja.patchValue({
          gestao: {
            totalProjeto: result.gestao.totalProjeto.toFixed(2),
            totalProjetoGestao: (result.gestao.totalProjeto + result.gestao.gestaoInforma).toFixed(2),
            custoHora: result.gestao.custoHora.toFixed(2),
            mediaEquipe: result.gestao.mediaEquipe.toFixed(2),
            totalHoras: result.gestao.totalHoras.toFixed(2),
            planejacol: result.planeja.planejacol.toFixed(2),
            gestaoInformaHoraInput: result.gestao.gestaoInforma.toFixed(2),
            riscoTecnicoHoraInput: result.gestao.riscoTecnico.toFixed(2),
          },
        });

        this.formAux = this.basicFormPlaneja.getRawValue();

        if (save) this.salvarAtualizar(result);
        else this.loading = false;
      }, 1000);
    });
  }

  private validaControles() {
    let valido = true;

    const checks = [
      ['planejamento.inicioPlanejaInput', 'planejamento.inicioPlanejaHoraInput'],
      ['planejamento.inicioPlanejaHoraInput', 'planejamento.inicioPlanejaHoraInput'],
      ['planejamento.especFuncInput', 'planejamento.especFuncHoraInput'],
      ['planejamento.especFuncHoraInput', 'planejamento.especFuncHoraInput'],
      ['planejamento.especTecnicaInput', 'planejamento.especTecnicaHoraInput'],
      ['planejamento.especTecnicaHoraInput', 'planejamento.especTecnicaHoraInput'],
      ['planejamento.testeIntegraInput', 'planejamento.testeIntegraHoraInput'],
      ['planejamento.testeIntegraHoraInput', 'planejamento.testeIntegraHoraInput'],
      ['planejamento.homologaCertiInput', 'planejamento.homologaCertiHoraInput'],
      ['planejamento.homologaCertiHoraInput', 'planejamento.homologaCertiHoraInput'],
      ['planejamento.implantaInput', 'planejamento.implantaHoraInput'],
      ['planejamento.implantaHoraInput', 'planejamento.implantaHoraInput'],
      ['planejamento.posImplanta', 'planejamento.implantaHoraInput'],
      ['gestao.gestaoInformaInput', 'gestao.gestaoInformaHoraInput'],
      ['gestao.gestaoInformaHoraInput', 'gestao.gestaoInformaHoraInput'],
      ['gestao.riscoTecnicoInput', 'gestao.riscoTecnicoHoraInput'],
      ['gestao.riscoTecnicoHoraInput', 'gestao.riscoTecnicoHoraInput'],
      ['param_comissao.valor', 'param_comissao.valor'],
    ];

    for (const [path] of checks) {
      const v = this.basicFormPlaneja.get(path as any)?.value;
      if (!this.campoNumerico(v)) {
        // rollback simples
        this.basicFormPlaneja.patchValue(this.formAux);
        valido = false;
        break;
      }
    }

    if (!valido) this.toastr.mostrarMensagem('aviso', 'Atenção!', 'O valor deve ser numérico.');
    return valido;
  }

  campoNumerico(valor: any) {
    if (valor === '' || isNaN(valor) || valor < 0) return false;
    return true;
  }

  calcularPercentual(event: Event, controlePercentual: string) {
    let percentual = 0;
    const horaString = (event.target as HTMLInputElement).value.toString();
    const horas = parseFloat(horaString).toFixed(2);

    percentual = (parseFloat(horas) * 100) / this.basicFormPlaneja.getRawValue().planejamento.construTeste;
    this.basicFormPlaneja.get(controlePercentual).patchValue(percentual.toFixed(2));
    this.calcular(true);
  }

  calcularPercentualGestaoRisco(event: Event, controlePercentual: string) {
    let percentual = 0;
    const horas: number = Number((event.target as HTMLInputElement).value) | 0;

    percentual = (horas * 100) / this.basicFormPlaneja.getRawValue().planejamento.planejacol;
    this.basicFormPlaneja.get(controlePercentual).patchValue(percentual.toFixed(2));
    this.calcular(true);
  }

  salvarAtualizar(erf: Erf = null) {
    this.loading = true;

    const paramComissaoForm = this.basicFormPlaneja.getRawValue().param_comissao;
    const isUpdate = paramComissaoForm && paramComissaoForm.id && paramComissaoForm.id > 0;

    const paramComissaoPayload = {
      id: isUpdate ? paramComissaoForm.id : 0,
      estimativaId: this.estimativaId,
      priceParamId: paramComissaoForm.priceParamId || 2,
      nome: paramComissaoForm.nome || 'Bonificação (%)',
      ativo: paramComissaoForm.ativo !== null ? paramComissaoForm.ativo : true,
      editavel: paramComissaoForm.editavel !== null ? paramComissaoForm.editavel : true,
      valor: Number(paramComissaoForm.valor) || 0,
    };

    const saveOrUpdate$ = isUpdate
      ? this.priceParamProjetoService.update(paramComissaoPayload)
      : this.priceParamProjetoService.create(paramComissaoPayload);

    saveOrUpdate$.subscribe(
      () => {
        const planeja = erf ? erf.planeja : this.basicFormPlaneja.getRawValue().planejamento;

        if (planeja.dtPrevInicio) {
          let data = planeja.dtPrevInicio;

          if (typeof data === 'string' && data.includes('/')) {
            const [dia, mes, ano] = data.split('/');
            planeja.dtPrevInicio = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
          } else if (data instanceof Date) {
            const dia = String(data.getDate()).padStart(2, '0');
            const mes = String(data.getMonth() + 1).padStart(2, '0');
            const ano = data.getFullYear();
            planeja.dtPrevInicio = `${ano}-${mes}-${dia}`;
          } else if (typeof data === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(data)) {
            planeja.dtPrevInicio = data.split('T')[0];
          }
        }

        this.planejamentoService.update(planeja).subscribe(
          () => {
            const gestao = erf ? erf.gestao : this.basicFormPlaneja.getRawValue().gestao;

            this.gestaoService.update(gestao).subscribe(
              () => {
                this.faturamentoService
                  .recalcularFaturamento(this.estimativaId)
                  .subscribe(
                    () => {
                      this.toastr.mostrarMensagem('sucesso', 'Sucesso', 'Registro atualizado com sucesso.');
                      this.comissaoAlterada.emit();

                      if (this.pendingPrazoEmit) {
                        this.staffPlanBridge.emitPrazoChange({
                          estimativaId: this.estimativaId,
                          action: this.pendingPrazoEmit.action,
                          novoPrazo: this.pendingPrazoEmit.novoPrazo,
                          delta: this.pendingPrazoEmit.delta,
                        });
                        this.pendingPrazoEmit = null;
                      }
                    },
                    (error) => this.misc.processError(error, 'Erro ao recalcular faturamento.'),
                  )
                  .add(() => (this.loading = false));

                this.habilitarAba();
              },
              (error) => {
                this.misc.processError(error, 'Erro ao salvar dados de gestão.');
                this.loading = false;
              },
            );
          },
          (error) => {
            this.misc.processError(error, 'Erro ao salvar dados de planejamento.');
            this.loading = false;
          },
        );
      },
      (error) => {
        this.misc.processError(error, 'Erro ao salvar parâmetros de projeto.');
        this.loading = false;
      },
    );
  }

  carregarDefaults(save: boolean) {
    return new Promise<void>((resolve, reject) => {
      if (
        this.basicFormPlaneja.getRawValue().planejamento.id === 0 &&
        this.basicFormPlaneja.getRawValue().gestao.id === 0
      ) {
        this.priceParamService.getByTipo('FP').subscribe(
          (result) => {
            result.items.forEach((e) => {
              switch (e.nome) {
                case 'InicioPlaneja':
                  this.basicFormPlaneja.patchValue({ planejamento: { inicioPlanejaInput: e.valor } });
                  break;
                case 'EspecFunc':
                  this.basicFormPlaneja.patchValue({ planejamento: { especFuncInput: e.valor } });
                  break;
                case 'EspecTecnica':
                  this.basicFormPlaneja.patchValue({ planejamento: { especTecnicaInput: e.valor } });
                  break;
                case 'AceiteInterno':
                  this.basicFormPlaneja.patchValue({ planejamento: { aceiteInternoInput: e.valor } });
                  break;
                case 'TesteIntegra':
                  this.basicFormPlaneja.patchValue({ planejamento: { testeIntegraInput: e.valor } });
                  break;
                case 'HomologaCert':
                  this.basicFormPlaneja.patchValue({ planejamento: { homologaCertiInput: e.valor } });
                  break;
                case 'Implanta':
                  this.basicFormPlaneja.patchValue({ planejamento: { implantaInput: e.valor } });
                  break;
                case 'PosImplanta':
                  this.basicFormPlaneja.patchValue({ planejamento: { posImplanta: e.valor } });
                  break;
                case 'DocCmmi':
                  this.basicFormPlaneja.patchValue({ planejamento: { docCmmi: e.valor } });
                  break;
                case 'GestaoInforma':
                  this.basicFormPlaneja.patchValue({ gestao: { gestaoInformaInput: e.valor } });
                  break;
                case 'RiscoTecnico':
                  this.basicFormPlaneja.patchValue({ gestao: { riscoTecnicoInput: e.valor } });
                  break;
                case 'Risco':
                  this.basicFormPlaneja.patchValue({ gestao: { risco: e.valor } });
                  break;
                case 'PrazoProjetoInput':
                  this.basicFormPlaneja.patchValue({ planejamento: { prazoProjetoInput: e.valor } });
                  break;
                case 'dtPrevInicio':
                  this.basicFormPlaneja.patchValue({ planejamento: { dtPrevInicio: e.valor } });
                  break;
              }
            });

            resolve();
          },
          (error) => {
            this.misc.processError(error, 'Não foi possível carregar os parâmetros padrões da estimativa.');
            reject();
          },
        );
      } else resolve();
    });
  }

  carregar() {
    return new Promise<void>((resolve, reject) => {
      this.planejamentoService.getById(this.estimativaId).subscribe((planeja) => {
        if (planeja) {
          if (planeja.dtPrevInicio) {
            const data = new Date(planeja.dtPrevInicio);
            const dia = String(data.getDate()).padStart(2, '0');
            const mes = String(data.getMonth() + 1).padStart(2, '0');
            const ano = data.getFullYear();
            planeja.dtPrevInicio = `${dia}/${mes}/${ano}`;
            this.dtPrevInicio = planeja.dtPrevInicio;
          }

          this.basicFormPlaneja.patchValue({
            planejamento: {
              id: planeja.id,
              inicioPlanejaInput: planeja.inicioPlanejaInput,
              especFuncInput: planeja.especFuncInput,
              especTecnicaInput: planeja.especTecnicaInput,
              aceiteInternoInput: planeja.aceiteInternoInput,
              construTeste: planeja.construTeste,
              testeIntegraInput: planeja.testeIntegraInput,
              homologaCertiInput: planeja.homologaCertiInput,
              implantaInput: planeja.implantaInput,
              posImplanta: planeja.posImplanta,
              docCmmi: planeja.docCmmi,
              risco: planeja.risco,
              planejacol: planeja.planejacol,
              prazoProjetoInput: planeja.prazoProjetoInput,
              dtPrevInicio: planeja.dtPrevInicio,
            },
          });
        }

        this.gestaoService.getById(this.estimativaId).subscribe(
          (gestao) => {
            if (gestao) {
              this.basicFormPlaneja.patchValue({
                gestao: {
                  id: gestao.id,
                  gestaoInformaInput: gestao.gestaoInformaInput,
                  gestaoInforma: gestao.gestaoInforma,
                  riscoTecnicoInput: gestao.riscoTecnicoInput,
                  riscoTecnico: gestao.riscoTecnico,
                  totalProjeto: gestao.totalProjeto,
                  mediaEquipe: gestao.mediaEquipe,
                  custoHora: gestao.custoHora,
                  totalHoras: gestao.totalHoras,
                  totalProjetoGestao: gestao.totalProjeto + gestao.gestaoInforma,
                },
              });
            }

            this.carregarDefaults(!this.somenteLeitura).then(() => {
              this.habilitarAba().add(() => resolve());
            });
          },
          (error) => {
            this.misc.processError(error, 'Não foi possível carregar os dados de gestão.');
            reject();
          },
        );
      });
    });
  }

  carregarParametros() {
    return new Promise((resolve, reject) => {
      this.priceParamProjetoService.getByEstimativa(this.estimativaId).subscribe({
        next: (result) => {
          if (result.items.length > 0) {
            result.items.forEach((el) => {
              switch (el.nome) {
                case 'Administrativo (%)':
                  this.basicFormPlaneja.patchValue({ param_administrativo: el.valor.toFixed(2) });
                  break;
                case 'Bonificação (%)':
                  this.basicFormPlaneja.patchValue({ param_comissao: el });
                  break;
                case 'Impostos (%)':
                  this.basicFormPlaneja.patchValue({ param_imposto: el.valor.toFixed(2) });
                  break;
                case 'Investimento (%)':
                  this.basicFormPlaneja.patchValue({ param_investimento: el.valor.toFixed(2) });
                  break;
              }
            });
          }
          resolve(true);
        },
        error: (error) => {
          this.misc.processError(error, 'Não foi possível recuperar os parâmetros administrativos da estimativa.');
          reject(false);
        },
      });
    });
  }

  disableAllControls(form: UntypedFormGroup) {
    Object.keys(form.controls).forEach((key) => {
      const control = form.get(key);
      if (control instanceof UntypedFormGroup || control instanceof UntypedFormArray) {
        this.disableAllControls(control as UntypedFormGroup);
      } else control.disable();
    });
  }

  onPrazoFocus() {
    const ctrl = this.basicFormPlaneja.get('planejamento.prazoProjetoInput');

    const raw = ctrl?.value;
    this.prazoWasEmptyOnFocus = raw === null || raw === undefined || raw === '';

    const v = Number(raw);
    this.prazoAnterior = Number.isFinite(v) ? v : null;
  }

  onPrazoBlur() {
    if (this.somenteLeitura) return;

    const ctrl = this.basicFormPlaneja.get('planejamento.prazoProjetoInput');
    if (!ctrl) return;

    const novoPrazo = Number(ctrl.value);

    if (!Number.isFinite(novoPrazo) || novoPrazo < 0 || novoPrazo > 99) {
      this.toastr.mostrarMensagem('aviso', 'Atenção!', 'Prazo inválido (0-99).');
      if (this.prazoAnterior != null) ctrl.setValue(this.prazoAnterior, { emitEvent: false });
      return;
    }

    const anterior = this.prazoAnterior ?? 0;
    const delta = novoPrazo - anterior;

    if (delta === 0) return;

    /**
     * CASO 1: Campo estava vazio ao entrar/focar e agora foi preenchido
     * Não abre modal. Só salva e dispara ação "append" (ou "truncate" se quiser, mas aqui não faz sentido pois não havia anterior válido).
     */
    if (this.prazoWasEmptyOnFocus) {
      this.salvarSomentePrazo(novoPrazo, () => {
        this.prazoAnterior = novoPrazo;

        // Quando era vazio, tratamos como append por padrão
        this.staffPlanBridge.emitPrazoChange({
          estimativaId: this.estimativaId,
          action: 'append',
          novoPrazo,
          delta,
        });

        this.toastr.mostrarMensagem('sucesso', 'Sucesso', 'Prazo atualizado.');
      });

      return;
    }

    /**
     * CASO 2: Já tinha valor antes → abre modal (aumento OU redução)
     */
    const msg = this.buildPrazoDialogMessage(delta);

    const ref = this.dialog.open(StaffPlanPrazoDialogComponent, {
      width: '720px',
      data: { titulo: 'Alteração no Prazo do Projeto', mensagem: msg, delta },
      panelClass: 'default-dialog-container',
    });

    ref.afterClosed().subscribe((action: PrazoAction) => {
      // Cancelar: volta SEM disparar eventos
      if (!action || action === 'cancel') {
        ctrl.setValue(anterior, { emitEvent: false });
        this.prazoAnterior = anterior;
        return;
      }

      const normalizedAction = this.normalizePrazoAction(action, delta);

      const emitToStaffPlan = () => {
        this.staffPlanBridge.emitPrazoChange({
          estimativaId: this.estimativaId,
          action: normalizedAction,
          novoPrazo,
          delta,
        });
      };

      if (normalizedAction === 'ai') {
        // guarda pra emitir depois que salvar terminar
        this.pendingPrazoEmit = { action: normalizedAction, novoPrazo, delta };

        // salva completo no back
        this.calcular(true);

        this.prazoAnterior = novoPrazo;
        return;
      }

      // manter configuração => append (delta>0) OU truncate/remove (delta<0)
      this.salvarSomentePrazo(novoPrazo, () => {
        this.prazoAnterior = novoPrazo;
        emitToStaffPlan();
        this.toastr.mostrarMensagem('sucesso', 'Sucesso', 'Prazo atualizado.');
      });
    });
  }

  private buildPrazoDialogMessage(delta: number): string {
    if (delta > 0) {
      return (
        `Você aumentou o prazo do projeto em ${delta} mês(es).\n\n` +
        `Escolha como deseja continuar:\n\n` +
        `• Gerar com IA: recalcula cronograma e recomendação.\n` +
        `• Manter configuração: adiciona ${delta} mês(es) no final com 0 horas.\n` +
        `• Cancelar: mantém o prazo anterior.`
      );
    }

    const abs = Math.abs(delta);
    return (
      `Você reduziu o prazo do projeto em ${abs} mês(es).\n\n` +
      `Escolha como deseja continuar:\n\n` +
      `• Gerar com IA: recalcula cronograma e recomendação (pode substituir ajustes manuais).\n` +
      `• Manter configuração: remove os ${abs} último(s) mês(es) do cronograma.\n` +
      `• Cancelar: mantém o prazo anterior.`
    );
  }

  private normalizePrazoAction(action: PrazoAction, delta: number): PrazoAction {
    if (action === 'ai' || action === 'cancel') {
      return action;
    }

    if (delta < 0 && action === 'remove') {
      return 'remove';
    }

    if (action === 'append' && delta < 0) {
      return 'remove';
    }

    return 'append';
  }

  // onPrazoBlur() {
  //   if (this.somenteLeitura) return;

  //   const ctrl = this.basicFormPlaneja.get('planejamento.prazoProjetoInput');
  //   if (!ctrl) return;

  //   const novoPrazo = Number(ctrl.value);

  //   if (!Number.isFinite(novoPrazo) || novoPrazo < 0 || novoPrazo > 99) {
  //     this.toastr.mostrarMensagem('aviso', 'Atenção!', 'Prazo inválido (0-99).');
  //     if (this.prazoAnterior != null) ctrl.setValue(this.prazoAnterior, { emitEvent: false });
  //     return;
  //   }

  //   const anterior = this.prazoAnterior ?? 0;
  //   const delta = novoPrazo - anterior;

  //   if (delta === 0) return;

  //   if (delta < 0) {
  //     this.toastr.mostrarMensagem('aviso', 'Atenção!', 'No momento não é possível diminuir o prazo. Apenas aumentar.');
  //     ctrl.setValue(anterior, { emitEvent: false });
  //     return;
  //   }

  //   if (this.prazoWasEmptyOnFocus) {
  //     this.salvarSomentePrazo(novoPrazo, () => {
  //       this.prazoAnterior = novoPrazo;

  //       this.staffPlanBridge.emitPrazoChange({
  //         estimativaId: this.estimativaId,
  //         action: 'append',
  //         novoPrazo,
  //         delta,
  //       });

  //       this.toastr.mostrarMensagem('sucesso', 'Sucesso', 'Prazo atualizado.');
  //     });

  //     return;
  //   }

  //   const msg =
  //     `Você aumentou o prazo do projeto em ${delta} mês(es).\n\n` +
  //     `Escolha como deseja continuar:\n\n` +
  //     `• Gerar com IA: recalcula cronograma e recomendação.\n` +
  //     `• Manter configuração: adiciona ${delta} mês(es) no final com 0 horas.\n` +
  //     `• Cancelar: mantém o prazo anterior.`;

  //   const ref = this.dialog.open(StaffPlanPrazoDialogComponent, {
  //     width: '720px',
  //     data: { titulo: 'Alteração no Prazo do Projeto', mensagem: msg, delta },
  //     panelClass: 'default-dialog-container',
  //   });

  //   ref.afterClosed().subscribe((action: PrazoAction) => {
  //     if (!action || action === 'cancel') {
  //       ctrl.setValue(anterior, { emitEvent: false });
  //       this.prazoAnterior = anterior;
  //       return;
  //     }

  //     const emitToStaffPlan = () => {
  //       this.staffPlanBridge.emitPrazoChange({
  //         estimativaId: this.estimativaId,
  //         action,
  //         novoPrazo,
  //         delta,
  //       });
  //     };

  //     if (action === 'ai') {
  //       this.pendingPrazoEmit = { action, novoPrazo, delta };

  //       this.calcular(true);

  //       this.prazoAnterior = novoPrazo;
  //       return;
  //     }

  //     this.salvarSomentePrazo(novoPrazo, () => {
  //       this.prazoAnterior = novoPrazo;
  //       emitToStaffPlan();
  //       this.toastr.mostrarMensagem('sucesso', 'Sucesso', 'Prazo atualizado.');
  //     });
  //   });
  // }

  private salvarSomentePrazo(novoPrazo: number, done?: () => void) {
    const planeja = this.basicFormPlaneja.getRawValue().planejamento;

    let dt = planeja.dtPrevInicio;
    if (typeof dt === 'string' && dt.includes('/')) {
      const [dia, mes, ano] = dt.split('/');
      dt = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
    } else if (typeof dt === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(dt)) {
      dt = dt.split('T')[0];
    }

    const payload = {
      ...planeja,
      estimativaId: this.estimativaId,
      prazoProjetoInput: novoPrazo,
      dtPrevInicio: dt ?? null,
    };

    this.loading = true;
    this.planejamentoService
      .update(payload)
      .subscribe({
        next: () => done?.(),
        error: (e) => this.misc.processError(e, 'Erro ao salvar prazo do projeto.'),
      })
      .add(() => (this.loading = false));
  }
}
